module.exports = __webpack_public_path__ + "img/time-icon.f5606b5f005145a5aee8ad03ceef6b9b.svg";